<template>
    <v-card tile class="drawer-content elevation-0 pb-12">

        <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
            <div class="d-inline">
                Create New User
            </div>
            <div class="d-inline">
                <v-btn
                    icon
                    outlined
                    color="info"
                    elevation="1"
                    @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
        </v-card-title>

        <v-form v-model="valid_create_save" ref="newuserform">
        <v-card-text class="pa-4">
            <v-row> 
                <v-col cols="12" sm="6" md="0" class="pb-0">    
                    <v-text-field 
                        v-model="createUser.first_name" 
                        :rules="firstNameRules"
                        required
                        label="First Name">
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.last_name" 
                        :rules="lastNameRules"
                        required
                        label="Last Name">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-autocomplete
                        v-model="createUser.title"
                        :items="Titles"
                        label="Title">
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="6" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.user_email" 
                        :rules="emailRules"
                        required
                        label="Email">
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.phone" 
                        label="Phone">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="6" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.company" 
                        label="Company">
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.website" 
                        label="Website">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.address" 
                        label="Mailing Address">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.address2" 
                        label="Second Address Line">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="5" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.city" 
                        label="City">
                    </v-text-field>
                </v-col>  
                <v-col cols="12" sm="4" md="0" class="pb-0">
                    <v-select
                        v-model="createUser.state"
                        :items="States"
                        label="State">
                    </v-select>
                </v-col>
                <v-col cols="12" sm="3" md="0" class="pb-0">
                    <v-text-field 
                        v-model="createUser.postal" 
                        label="Zip Code">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" sm="4" md="0" class="d-flex pb-0">
                    <v-autocomplete
                        v-model="createUser.group"
                        :items="user_roles"
                        label="Role(s)"
                        item-text="text"
                        item-value="value"
                        >
                    </v-autocomplete>
                </v-col>
                <v-col cols="8" sm="8"></v-col>
            </v-row>
        </v-card-text>

        <v-divider class="ma-4"></v-divider>
        
        <v-card-actions class="mt-6 px-4 justify-end align-center">
            <!-- <v-spacer></v-spacer> -->
            <v-checkbox
                v-model="createUser.generate_email"
                label="Generate Email"
                hide-details
                color="primary"
                class="d-inline ma-0 pa-0">
            </v-checkbox>
            <v-btn 
                color="primary" 
                dark
                class="ml-5"
                @click="createData">
                Create User
            </v-btn>
            <v-btn 
                color="primary" 
                outlined
                class="ml-5"
                @click="onClose">
                Cancel
            </v-btn>
        </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>  
  export default {
    name: 'CreateUser',
    props: {
        AssignModules: Array,
        States: Array,
        Titles: Array,
        saveCreateData: Function,
        closeCreate: Boolean
    },
    data () {
        return {
            createUser: {
                last_name: '',
                first_name: '',
                user_email: '',
                title: '', 
                company: '', 
                website: '',
                phone: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                postal: '',
                country: '',
                created_date: '',
                is_active: true,
                group: [4],
                add_modules: '',
                generate_email: true,
            },
            user_roles: [
                {
                    text: "SRG Admin",
                    value: 6
                },
                {
                    text: "Client",
                    value: 4
                },
                {
                    text: "Partner Firm",
                    value: 7
                },
                // {
                //     text: "Seller",
                //     value: 10
                // }
            ],
            valid_create_save: false,
            firstNameRules: [
                (v) => !!v || 'First Name is required'
            ],
            lastNameRules: [
                (v) => !!v || 'Last Name is required'
            ],
            emailRules: [
                (v) => !!v || 'Email is required',
                (v) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/.test(v) || 'Email must be in valid format'
            ],
        }
    },
    
    mounted() {},
    
    methods: {
        onClose: function () {
            this.$emit('closeCreate', !this.closeCreate)
        },
        createData: function () {
            this.$refs.newuserform.validate();
            if(this.valid_create_save){
                this.$emit('saveCreateData', this.createUser);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/CreateUser.vue